import store from '@/store';
import { errorMessages } from '@/globals/errorMessages';
import { get } from './api/http.service';
import EventBus from '@/utils/eventBus';
import { EventBusEvents } from '@/globals/enums';
import { authService } from './auth.service';
import Vue from 'vue';
import { getCameraGroupList } from './ccs.group.service';

export default class VideoService {
  async getCameraList() {
    try {
      store.dispatch('common/setCameraListLoading', true);
      const params = {};
      const response = await get('/ccs/v1/camera/list', params);
      const cameraList = response.cameraLists.map((el) => {
        el.loading = false;
        return el;
      });

      store.dispatch('common/changeCameraList', cameraList);
      EventBus.emit(EventBusEvents.CameraListLoaded, cameraList);
      return response;
    } catch (error) {
      console.error(error);
      return errorMessages.API_ERROR;
    } finally {
      store.dispatch('common/setCameraListLoading', false);
    }
  }
  async getCameraListWithGroup() {
    try {
      store.dispatch('common/setCameraListLoading', true);
      const params = {};
      const [cameraResponse, groups] = await Promise.all([
        get('/ccs/v1/camera/list', params),
        getCameraGroupList(),
      ]);
      const cameraList = cameraResponse.cameraLists.map((el) => {
        el.loading = false;
        return el;
      });
      store.dispatch('common/changeCameraList', { cameraList, groups });

      EventBus.emit(EventBusEvents.CameraListLoaded, cameraList);
      return cameraResponse;
    } catch (error) {
      console.error(error);
      return errorMessages.API_ERROR;
    } finally {
      store.dispatch('common/setCameraListLoading', false);
    }
  }

  async attachCameraIamAccessKey(cameraList) {
    if (cameraList.length === 0) {
      console.warn('No camera to attach IAM Access Key');
      return;
    }
    const result = await authService.getIamAccessKey(
      cameraList.map((cam) => cam.id)
    );
    const { accessKeyId, secretAccessKey, sessionToken } = result;
    const credentials = {};
    cameraList.forEach((cam) => {
      Vue.set(cam, 'accessKeyId', accessKeyId);
      Vue.set(cam, 'secretAccessKey', secretAccessKey);
      Vue.set(cam, 'sessionToken', sessionToken);
      credentials[cam.id] = {
        id: cam.id,
        accessKeyId,
        secretAccessKey,
        sessionToken,
      };
    });
    return credentials;
  }

  async getVideoEvents(params) {
    return get('/ccs/v1/admin/hm/videoEvents', params)
      .then(function (response) {
        return response;
      })
      .catch(function (err) {
        console.log(err);
        return errorMessages.API_ERROR;
      });
  }
}

export const videoService = new VideoService();
